<template>
  <div class="order-details">
    <div class="title">套餐划扣信息</div>
    <div class="opTop box">
      <ul>
        <li>套餐销售数量：{{ packageData.packageCount }} </li>
        <li>
          项目产品销售数量：{{ packageData.itemAndProductCount }}
          <el-tooltip class="item" effect="light" content="（套餐内包含的项目数量+产品数量）×套餐销售数量" placement="right">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </li>
        <li>
          套餐划扣总次数：{{ packageData.itemAndProductDeductCount }}
          <el-tooltip class="item" effect="light" content="套餐内包含的项目划扣次数+产品划扣次数" placement="right">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </li>
        <li>
          套餐划扣率：{{ packageData.deductRate }}%
          <el-tooltip class="item" effect="light" content="套餐划扣次数÷套餐内项目产品销售数量×100%" placement="left">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </li>
      </ul>
    </div>
    <div v-show="packageData.itemInfo.length >0" class="title">套餐项目划扣信息</div>
    <el-table v-show="packageData.itemInfo.length >0" :data="packageData.itemInfo" tooltip-effect="light" class="box">
      <el-table-column label="包含项目" width="160px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.itemName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="itemNumber" label="项目数量"></el-table-column>
      <el-table-column prop="itemSellNum">
        <template slot="header" slot-scope="scope">
          销售数量
          <el-tooltip v-show="scope" class="item" effect="light" :content="'套餐内包含此项目的数量×套餐销售数量'" placement="right">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="itemDeductNum" label="划扣次数"></el-table-column>
      <el-table-column prop="itemDeductPercentage">
        <template slot="header" slot-scope="scope">
          划扣率
          <el-tooltip v-show="scope" class="item" effect="light" :content="'划扣次数÷项目销售数量×100%'" placement="left">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.itemDeductPercentage }}%</span>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="packageData.productInfo.length >0" class="title">套餐产品划扣信息</div>
    <el-table v-show="packageData.productInfo.length >0" :data="packageData.productInfo" tooltip-effect="light" class="box">
      <el-table-column label="包含产品" width="160px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.productName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productNumber" label="产品数量"></el-table-column>
      <el-table-column prop="productSellNum">
        <template slot="header" slot-scope="scope">
          销售数量
          <el-tooltip v-show="scope" class="item" effect="light" :content="'套餐内包含此产品的数量×套餐销售数量 '" placement="right">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="productDeductNum" label="划扣次数"></el-table-column>
      <el-table-column prop="productDeductPercentage">
        <template slot="header" slot-scope="scope">
          划扣率
          <el-tooltip v-show="scope" class="item" effect="light" :content="'划扣次数÷产品销售数量×100%'" placement="left">
            <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.productDeductPercentage }}%</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

export default {
  props: {
    packageData: {
      type: Object,
      default: Object
    }
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style>
.el-dialog__body {
    overflow-x: visible !important;
}
.opTop {
    background: #f5f7fa;
}
li {
    list-style: none;
}
.opTop ul {
    padding: 18px 20px;
}
.opTop ul li {
    width: 24%;
    display: inline-block;
}
</style>
